import { useTranslation } from "react-i18next";
import Header from "../../global/header";
import { Row, Card, Col, Container, Button } from "react-bootstrap";
import Title from "../Title/Title";
import Language from "../Language/Langauge";
import { appConfig } from "../../config/appConfig";
import Footer from "../../global/footer";
import "./RestartPage.css";
import tokenService from "../../service/token.service";
import { useEffect } from "react";

const RestartPage = () => {
  const { t } = useTranslation();
  const fromMobile= tokenService.getFromMobile()
  const handleClick = () => {
    tokenService.clearSessionData();
    localStorage.removeItem("visitedEmailHidden")
    window.location.href = fromMobile
      ? appConfig.LOGOUT_URL_MOBILE
      : appConfig.LOGOUT_URL_WEB;
  };
  return (
    <>
      <Header />
      <Container className="restartPage">
        <Row>
          <Col lg="1" />
          <Col lg="10" className="middlePadding">
            <div>
              <Title logoType="success"> {t("TEXT_RESTART_PAGE_TITLE")}</Title>
              <Language />
            </div>
            <div className="mb-3">
              <Card className="card contentCard" text="black">
                <Card.Body className="linkBody">
                  <Card.Link
                    className="cardLink"
                    target="_blank"
                    href={appConfig.EMAIL_HIDDEN_INSTRUCTION_URL}
                  >
                    {t("TEXT_EMAIL_HIDDEN_INSRUCTION_8")}
                  </Card.Link>
                </Card.Body>
                <Card.Body>
                  <Card.Text className="cardText">
                    {t("TEXT_RESTART_PAGE_INSRUCTION_1")}
                  </Card.Text>
                  <Card.Text className="cardText">
                    {t("TEXT_RESTART_PAGE_INSRUCTION_2")}
                  </Card.Text>
                  <Card.Text className="cardText">
                    {t("TEXT_RESTART_PAGE_INSRUCTION_3")}
                  </Card.Text>
                </Card.Body>
              </Card>
              <div className="d-grid gap-2">
                <Button onClick={handleClick} className="backBtn">
                  {t("LABEL_LOGOUT_AND_TRY_AGAIN")}
                </Button>
              </div>
            </div>
            <Footer />
          </Col>
          <Col lg="1" />
        </Row>
      </Container>
    </>
  );
};

export default RestartPage;
